<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-row class="question-errors">
          <b-col
            cols="12"
            v-if="validate && validate.$error"
          >
            <div
              class="invalid-feedback"
            >
              <h3>{{ formAnswersData[field.section].validationMessage }}</h3>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-form-row
      class="question-answer"
      v-if="field.type === 'select'"
    >
      <div
        class="col pb-3"
      >
        <b-form-select
          v-model="formAnswers[field.section]"
          :options="field.options"
          size="lg"
        />
      </div>
    </b-form-row>
    <div
      class="row"
      v-if="field.type === 'date'"
    >
      <div class="col pb-3">
        <b-datepicker
          id="example-datepicker"
          v-model="formAnswers[field.section]"
          :date-format-options="dateFormatOptions"
        />
      </div>
    </div>
    <div
      class="row"
      v-if="field.type === 'time'"
    >
      <div class="col pb-3">
        <b-timepicker
          v-model="formAnswers[field.section]"
          type="time"
          locale="en"
        />
      </div>
    </div>
    <!--    </span><span v-if="question.type === 'radio'">-->
    <!--      Radio-->
    <!--    </span><span v-if="question.type === 'checkbox'">-->
    <!--      Checkbox-->
    <!--    </span>-->
    <div
      class="row question-checkboxes justify-content-center"
      v-if="field.type === 'checkbox'"
    >
      <div
        class="col-5 pb-3"
        v-for="value in field.values"
        :key="value.id"
      >
        <b-checkbox
          size="lg"
          v-model="formAnswers[field.section][value.id]"
        >
          {{ value.answer_text }}
        </b-checkbox>
      </div>
    </div>

    <div
      class="row"
      v-if="field.type === 'radio'"
    >
      <div class="col pb-3">
        <b-radio-group>
          <b-radio
            v-for="value in field.values"
            :key="value.id"
            v-model="formAnswers[field.section][value.id]"
          >
            {{ value.answer_text }}
          </b-radio>
        </b-radio-group>
      </div>
    </div>

    <div
      class="row"
      v-if="field.type === 'text'"
    >
      <b-input
        type="text"
        v-model="formAnswers[field.section]"
        class="col-md-8 offset-md-2 pb-3"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'GenericQuestion',
  props: {
    formAnswers: {},
    field: {},
    question: {},
    validate: null,
    formAnswersData: {}
  },
  data () {
    return {
      dateFormatOptions: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    }
  },
  computed: {}
}
</script>
